'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.authRender = exports.checkForAccess = exports.authReady = exports.search = exports.footer = exports.appPromo = exports.secondary = exports.primary = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _rpAuth = require('rp-auth');

require('jquery-ui/ui/position.js');

var _rpAnalytics = require('rp-analytics');

var segmentio = _interopRequireWildcard(_rpAnalytics);

var _authPrefsLoader = require('./navigation/authPrefsLoader');

var _authPrefsLoader2 = _interopRequireDefault(_authPrefsLoader);

var _primaryMenu = require('./navigation/primaryMenu');

var _primaryMenu2 = _interopRequireDefault(_primaryMenu);

var _secondaryMenu = require('./navigation/secondaryMenu');

var _secondaryMenu2 = _interopRequireDefault(_secondaryMenu);

var _appPromo = require('./appPromo/appPromo');

var _appPromo2 = _interopRequireDefault(_appPromo);

var _search = require('./search/search');

var _search2 = _interopRequireDefault(_search);

var _footer = require('./footer/footer');

var _footer2 = _interopRequireDefault(_footer);

var _freeBets = require('./utils/freeBets');

var _freeBets2 = _interopRequireDefault(_freeBets);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var primary = new _primaryMenu2.default('#primaryNav');
var secondary = new _secondaryMenu2.default('#secondaryNav');
var appPromo = new _appPromo2.default();
var footer = new _footer2.default();
var search = new _search2.default();

(0, _freeBets2.default)('.rn-menuBar__navItem__freeBets');

var $authPrefsUrl = (0, _jquery2.default)('[data-auth-prefs-url]');
var authReady = (0, _authPrefsLoader2.default)($authPrefsUrl.data('auth-prefs-url')).then(function (auth) {
    (0, _rpAuth.render)();
    (0, _rpAuth.checkForAccess)('Subscriptions');

    return auth;
});

function constructGlobalAuthApi() {
    global.authApi = global.authApi || {};

    var authReadyExternal = new _promise2.default(function (resolve, reject) {
        authReady.finally(resolve);
    });

    global.authApi.authReady = authReadyExternal; // exposes only the success/error of the authentification, no other data
}

constructGlobalAuthApi();

/**
 * Bind menu bar tracking event
 */
(0, _jquery2.default)('.rn-menuBar').on('click', function (event) {
    var $menuItem = (0, _jquery2.default)(event.target).closest('.rn-menuBar__navItem');
    if ($menuItem[0] && !(0, _jquery2.default)(event.target).closest('.bs-switchBookmakers')[0]) {
        var selection = (0, _jquery2.default)((0, _jquery2.default)($menuItem[0]).find('span')[0]).text().trim().split('/')[0];

        segmentio.trackNavigationClick((0, _defineProperty3.default)({}, segmentio.TRAIT_SELECTION, selection));
    }
});

exports.primary = primary;
exports.secondary = secondary;
exports.appPromo = appPromo;
exports.footer = footer;
exports.search = search;
exports.authReady = authReady;
exports.checkForAccess = _rpAuth.checkForAccess;
exports.authRender = _rpAuth.render;


//////////////////
// WEBPACK FOOTER
// ./~/rp-navigation/lib/index.js
// module id = 259
// module chunks = 1